import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../admin-on-rest/src/i18n/translate';
import { BMTheme } from "../../BMTheme";

const Title = ({ defaultTitle, record, title, translate }) => {
    if (!title) {
        return <span>{defaultTitle}</span>;
    }
    if (typeof title === 'string') {
        return <span style={{color:`${BMTheme.icons.color}`, fontWeight: '300'}}>{translate(title, { _: title })}</span>;
    }
    return React.cloneElement(title, { record });
};

Title.propTypes = {
    defaultTitle: PropTypes.string.isRequired,
    record: PropTypes.object,
    translate: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default translate(Title);



// WEBPACK FOOTER //
// ./src/components/CRM/Title.js